import FileDownloadOutlined from "@mui/icons-material/FileDownloadOutlined";
import {lazy} from "react";
import type {Page, PageGroup} from "router/types";

const ExportsPage = lazy(() => import("pages/exports/ExportsPage"));

const exportsRoutes: Array<Page | PageGroup> = [
  {
    segment: "exports",
    title: "Exports",
    Icon: FileDownloadOutlined,
    Component: ExportsPage,
  },
];
export default exportsRoutes;
